import { ArticleHeading3 } from '@cian/ui-kit';

import { type FC } from 'react';

import { type SmartHomeCard as SmartHomeCardModel } from '../../types';

import styles from './SmartHomeCard.css';

type SmartHomeCardProps = {
  card: SmartHomeCardModel;
};

export const SmartHomeCard: FC<SmartHomeCardProps> = ({ card }) => {
  return (
    <article className={styles['card']} data-testid="smart-home-card">
      <ArticleHeading3 data-testid="smart-home-card-title" fontWeight="normal">
        {card.title}
      </ArticleHeading3>
      <div className={styles['image-wrapper']}>
        <img
          alt={card.imageAlt}
          className={styles['image']}
          data-testid="smart-home-card-image"
          decoding="async"
          loading="lazy"
          src={card.imageSrc}
        />
      </div>
    </article>
  );
};
